import React from "react";
import { motion } from "framer-motion";
import S from "./MainHero.styled";
import { Flex } from "@/styles/global";
import { gatsbyImageHelper, isLight } from "@/src/helpers";
import { DisplayHeadingS, DisplayHeadingL } from "@/styles/typography";
import { ColorOptions, IWPImage, IWPLink, IWPTitleParts } from "@/src/types";
import { TextButton, BackgroundImage, Wysiwyg } from "@/styles/components";
import TitleParts from "@/components/global-components/TitleParts";

export interface MainHeroProps {
  titleParts: IWPTitleParts;
  title: string;
  titleSmall: string;
  text: string;
  link: IWPLink;
  secondaryLink: IWPLink;
  alignContent?: "left" | "right";
  gradientColor?: ColorOptions;
  showGradient: boolean;
  backgroundImage: IWPImage;
  backgroundImageMobile: IWPImage;
}

const MainHero: React.FC<MainHeroProps> = ({
  titleParts,
  title,
  titleSmall,
  text,
  link,
  secondaryLink,
  alignContent,
  gradientColor,
  backgroundImage,
  backgroundImageMobile,
  showGradient,
}) => {
  const alignContentLeft = alignContent === "left";

  const backgroundImageData = gatsbyImageHelper(backgroundImage);
  const backgroundImageMobileData = gatsbyImageHelper(backgroundImageMobile);

  return (
    <S.Section>
      {backgroundImageData && (
        <S.BackgroundImage
          image={backgroundImageData}
          alt={backgroundImage.altText || ""}
          $overlay={showGradient ? gradientColor : undefined}
          $reverseOverlay={!alignContentLeft}
          objectFit="cover"
          objectPosition="center"
        />
      )}
      {backgroundImageMobileData ? (
        <S.MobileBackgroundImage
          image={backgroundImageMobileData}
          alt={backgroundImageMobile.altText || ""}
          $overlay={gradientColor ? gradientColor : undefined}
          objectFit="cover"
          objectPosition="center"
        />
      ) : backgroundImageData ? (
        <S.MobileBackgroundImage
          image={backgroundImageData}
          alt={backgroundImage.altText || ""}
          $overlay={gradientColor ? gradientColor : undefined}
          objectFit="cover"
          objectPosition="center"
        />
      ) : null}

      <S.Inner>
        <S.TextContainer alignLeft={alignContentLeft}>
          <DisplayHeadingL
            color={
              gradientColor === "yellow"
                ? "brown"
                : isLight(gradientColor)
                  ? "black"
                  : "creme"
            }
            // as={motion.h1}
            // initial={{ opacity: 0, y: -10 }}
            // whileInView={{ opacity: 1, y: 0 }}
            // transition={{ duration: 0.5 }}
            // viewport={{ once: true }}
          >
            {titleParts ? (
              <TitleParts
                titleParts={titleParts}
                backgroundColor={gradientColor || "black"}
              />
            ) : (
              title && title
            )}
          </DisplayHeadingL>

          {titleSmall && (
            <DisplayHeadingS
              color={
                gradientColor === "yellow"
                  ? "brown"
                  : isLight(gradientColor)
                    ? "black"
                    : "creme"
              }
              // as={motion.h3}
              // initial={{ opacity: 0, y: -10 }}
              // whileInView={{ opacity: 1, y: 0 }}
              // transition={{ duration: 0.5 }}
              // viewport={{ once: true }}
            >
              {titleSmall}
            </DisplayHeadingS>
          )}
          {text && (
            <Flex
            // as={motion.div}
            // initial={{ opacity: 0, y: -5 }}
            // whileInView={{ opacity: 1, y: 0 }}
            // transition={{ duration: 0.5, delay: 0.5 }}
            // viewport={{ once: true }}
            >
              <S.Text
                color={
                  gradientColor === "yellow"
                    ? "brown"
                    : isLight(gradientColor)
                      ? "black"
                      : "creme"
                }
                size={16}
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </Flex>
          )}
          <Flex
            $desktopGap={32}
            $gap={4}
            $margin={"24px 0 0"}
            $desktopDir="row"
            $column
            // as={motion.div}
            // initial={{ opacity: 0, y: -5 }}
            // whileInView={{ opacity: 1, y: 0 }}
            // transition={{ duration: 0.5, delay: 0.5 }}
            // viewport={{ once: true }}
          >
            <TextButton wpLink={link} />
            <TextButton black wpLink={secondaryLink} />
          </Flex>
        </S.TextContainer>
      </S.Inner>
    </S.Section>
  );
};

export default MainHero;
